import React from 'react';
import _ from 'lodash';
import FleetCalendar from '../../components/FleetCalendar';
import { CALENDAR_TYPE } from '../../components/FleetCalendar/constants';
import AuthUserContainer from '../../containers/AuthUser';

function Schedule({ permissions, match }) {
	const scheduleType = _.get(match, 'params.scheduleType');
	if (!permissions || !_.includes(permissions, 'canUpdateScheduling')) {
		return <div>You do not have valid permissions to view this page.</div>;
	}

	if (scheduleType === 'users' || scheduleType === 'drivers') {
		return <FleetCalendar calendarType={CALENDAR_TYPE.users} />;
	} else if (scheduleType === 'trucks') {
		return <FleetCalendar calendarType={CALENDAR_TYPE.trucks} />;
	} else {
		return <div>Missing scheduleType</div>;
	}
}

export default _.flow([AuthUserContainer])(Schedule);
